import { render, staticRenderFns } from "./confirm-letter.vue?vue&type=template&id=472d3e17&"
import script from "./confirm-letter.vue?vue&type=script&lang=js&"
export * from "./confirm-letter.vue?vue&type=script&lang=js&"
import style0 from "./confirm-letter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports